import React from 'react';
import { Row, Col, Modal, ModalBody, ModalFooter, Label } from 'reactstrap';
import moment from 'moment';
import { ReactComponent as DownloadIcon } from '../../assets/images/Download_Icon.svg';
import styles from './ViewDocumentModal.module.css';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import { pdfjs } from 'react-pdf';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';

pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export default function ViewDocumentModal({ isOpen, toggle, centered, selectedDoc = '', country = 'us', contract }) {
    const isPdf = selectedDoc?.documentName.toLowerCase().indexOf('pdf') > -1 ? true : false;
    let file = '';
    let fileUrl = '';

    const byteCharacters = atob(selectedDoc?.documentData);
    const byteNumbers = Array.from(byteCharacters, (c) => c.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);

    if (isPdf) {
        file = new Blob([byteArray], { type: 'application/pdf' });
    } else {
        file = new Blob([byteArray], { type: 'image/png' });
    }
    fileUrl = URL.createObjectURL(file);

    return (
        <Modal
            isOpen={isOpen}
            toggle={toggle}
            centered={centered}
            size='lg'
        >
            <div className={styles.viewDocmodalHeader}>
                <div>
                    <h4
                        className={styles.modalTitle}
                        id='exampleModalLongTitle'
                    >
                        {selectedDoc?.documentName}
                    </h4>
                </div>
                <div className={styles.iconBtn}>
                    <DownloadIcon
                        id='downloadDocs'
                        onClick={() => window.open(fileUrl, '_blank')}
                    />
                </div>
            </div>

            <ModalBody className={styles.viewDocmodalBody}>
                <Row>
                    <Col className={styles.docDetailslist}>
                        <ul>
                            <li>
                                <Label className='form-label'>Date</Label>
                                <p>
                                    {country.toLowerCase() === 'ca'
                                        ? moment(selectedDoc?.createdDate).format('DD/MM/YYYY hh:mm A')
                                        : moment(selectedDoc?.createdDate).format('MM/DD/YYYY hh:mm A')}
                                </p>
                            </li>
                            <li>
                                <Label className='form-label'>Type of Document</Label>
                                <p>{selectedDoc?.documentTypeName}</p>
                            </li>
                        </ul>
                    </Col>
                    <Col
                        md='8'
                        className={
                            selectedDoc?.documentName !== undefined && isPdf ? styles.pdfViewer : styles.docImage
                        }
                    >
                        {selectedDoc?.documentName !== undefined && isPdf ? (
                            <Worker workerUrl='https://unpkg.com/pdfjs-dist@2.5.207/build/pdf.worker.js'>
                                <div>
                                    <Viewer
                                        fileUrl={byteArray}
                                        plugins={[]}
                                    />
                                </div>
                            </Worker>
                        ) : (
                            <img
                                alt='document'
                                title={selectedDoc?.documentName}
                                src={`/document/GetFileContentByContractIdAndDocumentId/${contract?.contractId}/${selectedDoc?.documentId}/hvac`}
                                style={{ maxWidth: '100%', height: 'auto' }}
                            />
                        )}
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <button
                    className='btn-primary'
                    onClick={toggle}
                >
                    Close
                </button>
            </ModalFooter>
        </Modal>
    );
}
